<div class="container">
    <div class="card">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="card-header d-flex justify-content-between">
                {{isAddMode ? 'New' : 'Edit'}} ASSR Test
                <button type="button" (click)="this.printService.print(['details', print], 'ASSR Test')" class="btn btn-primary px-2 py-0"><i class="mdi mdi-printer"></i></button>  
            </div>
            <div #print class="card-body"> 
                <fieldset >
                    <div class="form-row">
                        <div class="form-group col-4">
                            <label for="dateOfTest">Date of Test</label>
                            <div>
                                <input matInput [matDatepicker]="picker" formControlName="dateOfTest" [ngClass]="{ 'is-invalid': submitted && f.dateOfTest.errors }" />
                                <mat-datepicker-toggle matSuffix [for]="picker">
                                    <i class="mdi mdi-calendar"></i>
                                </mat-datepicker-toggle>
                                <div *ngIf="submitted && f.dateOfTest.errors" class="invalid-feedback">
                                    <div *ngIf="f.dateOfTest.errors.required">Date of Test is required</div>
                                </div>
                                <mat-datepicker #picker></mat-datepicker>
                            </div>
                        </div>
                        <div class="form-group col-4">
                            <label for="nameOfTester">Name of Tester</label>
                            <input type="text" formControlName="nameOfTester" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.nameOfTester.errors }" />
                            <div *ngIf="submitted && f.nameOfTester.errors" class="invalid-feedback">
                                <div *ngIf="f.nameOfTester.errors.required">Name of Tester is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-4">
                            <label for="reader">Reader</label>
                            <input type="text" formControlName="reader" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.reader.errors }" />
                            <div *ngIf="submitted && f.reader.errors" class="invalid-feedback">
                                <div *ngIf="f.reader.errors.required">Reader is required</div>
                            </div>
                        </div>
                        <div class="form-group col-4">
                            <label for="device">Machine(serial number)</label>
                            <input type="text" formControlName="device" class="form-control" [matAutocomplete]="auto"/>
                            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                <mat-option *ngFor="let machine of allMachine$ | async as allMachine">
                                  {{machine.dataModel.brand}}({{machine.dataModel.serialNumber}})
                                </mat-option>
                            </mat-autocomplete>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group">
                            <label for="testingConditions">Testing Conditions</label>
                            <div>
                                <mat-radio-group formControlName="testingConditions">
                                    <mat-radio-button class="mr-3" [value]="'Natural Sleep'">Natural Sleep</mat-radio-button>
                                    <mat-radio-button class="mr-3" [value]="'Sedated'">Sedated</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-6 d-flex justify-content-center">
                            <mat-checkbox formControlName="leftEarDone">
                                Left Ear
                            </mat-checkbox>
                        </div>
                        <div class="form-group col-6 d-flex justify-content-center">
                            <mat-checkbox formControlName="rightEarDone">
                                Right Ear
                            </mat-checkbox>
                        </div>
                    </div>  
                    <div class="form-row">
                        <div class="form-group col-6 ">
                            <label for="transducersLeftEar">Transducers</label>
                            <div>
                                <mat-radio-group formControlName="transducersLeftEar">
                                    <mat-radio-button class="mr-3" [value]="'Insert Earphones'">Insert Earphones</mat-radio-button>
                                    <mat-radio-button class="mr-3" [value]="'Bone Conductor'">Bone Conductor</mat-radio-button>
                                    <mat-radio-button [value]="'Headphones'">Headphones</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="form-group col-6">
                            <label for="transducersRightEar">Transducers</label>
                            <div>
                                <mat-radio-group formControlName="transducersRightEar">
                                    <mat-radio-button class="mr-3" [value]="'Insert Earphones'">Insert Earphones</mat-radio-button>
                                    <mat-radio-button class="mr-3" [value]="'Bone Conductor'">Bone Conductor</mat-radio-button>
                                    <mat-radio-button [value]="'Headphones'">Headphones</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                    <label>Findings</label>
                    <div class="form-row">
                        <div class="form-group col-1">
                            <label>
                                Left Ear
                            </label>
                        </div>
                        <div class="form-group col-1">
                            <label>250Hz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>500Hz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>1kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>1.5kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>2kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>3kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>4kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>6kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>8kHz</label>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-1"></div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsLeftEar250" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsLeftEar500" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsLeftEar1000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsLeftEar1500" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsLeftEar2000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsLeftEar3000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsLeftEar4000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsLeftEar6000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsLeftEar8000" class="form-control" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-1">
                            <label>
                                Right Ear
                            </label>
                        </div>
                        <div class="form-group col-1">
                            <label>250Hz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>500Hz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>1kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>1.5kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>2kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>3kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>4kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>6kHz</label>
                        </div>
                        <div class="form-group col-1">
                            <label>8kHz</label>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-1"></div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsRightEar250" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsRightEar500" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsRightEar1000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsRightEar1500" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsRightEar2000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsRightEar3000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsRightEar4000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsRightEar6000" class="form-control" />
                        </div>
                        <div class="form-group col-1">
                            <input type="text" formControlName="findingsRightEar8000" class="form-control" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for="notes">Notes</label>
                            <input type="text" formControlName="notes" class="form-control" />
                        </div>
                    </div>
                    <div class="form-row">
                        <label for="uploadFile">Upload</label>
                        <!-- <div *ngIf="form.value.uploadFile" class="form-row ml-3">
                            <div class="form-group">
                                <a role="button" (click)="download(form.value.uploadFile)"><u>click to download file</u></a>
                            </div>
                        </div> -->
                        <div class="form-row ml-3">
                            <div class="form-group">
                                <!-- <input type="file" id="file" class="form-control" (change)="handleFileInput($event.target.files)"/> -->
                                <input-file formControlName="uploadFile" (change)="handleFileInput($event.target.files)"></input-file>
                                <!-- <input type="file" id="file" class="form-control" accept="application/pdf,image/jpeg" (change)="handleFileInput($event.target.files)"/> -->
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group mt-3 col-12">
                            <div class="d-flex justify-content-center">
                                <div class="col-md-10">
                                    <button [disabled]="loading" class="btn btn-primary btn-block text-nowrap">
                                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                        {{isAddMode ? 'Add' : 'Save'}} Record
                                    </button>
                                    <div class="d-flex justify-content-around flex-wrap mt-2">
                                        <a (click)="this.dialogRef.close()" class="btn btn-link">Cancel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </form>
    </div>
</div>